import axios from "axios"
export default{
    methods:{
        //manage Address functions

        // cart functions
        updateCart() {
            // this.total = this.getCartTotal()
            // this.cartLength = this.cart.length
            localStorage.setItem("cart", JSON.stringify(this.cart));
        },
        addqty(pid) {
            //  alert(pid);
            var objIndex = this.cart.findIndex((obj => obj.product_id == pid));
            var qty_old = parseInt(this.cart[objIndex].qty);
            this.cart[objIndex].qty = qty_old + 1;
            // alert(objIndex)
            this.updateCart();
        },
        subqty(pid) {
            // alert(pid+" "+q)
            var objIndex = this.cart.findIndex((obj => obj.product_id == pid));
            var q = parseInt(this.cart[objIndex].qty);
            if (q > 1) {
                this.cart[objIndex].qty -= 1;

            } else {
                this.cart.splice(objIndex, 1); //to Remove Element from Arry
            }
            // alert(this.cart[objIndex].qty)
            this.updateCart(); 
        },
        addToCart(pid, pname, price, packing, measure) {

            this.customer_id = localStorage.getItem("customer_id");
            // console.log("add to cart Call");
            //this.showLogin();
            //alert("welcome customer : "+this.customer_id);
            if (this.cart == null) {
                this.cart = []
            }
           
            if (this.cart.length > 0 && this.cart != null) {
              //  alert(this.cart[0].cid + "   "+this.customer_id)
                if (this.cart[0].cid == this.customer_id || this.cart[0].cid == "") {
                    var objIndex = this.cart.findIndex((obj => obj.product_id == pid));
                    if (objIndex < 0) {
                       
                        this.cart.push({
                            product_id: pid,
                            name: pname,
                            mrp: price,
                            qty: 1,
                            cid: this.customer_id,
                            packing: packing,
                            measure: measure
                        });
                    } else {
                //        alert("cart "+this.cart.length)
                        this.cart[objIndex].qty += 1;
                    }
                }
            } else {
                // when array is empty
                this.addNewObject(pid, pname, price, packing, measure)
            }

            console.log(this.cart);
            

            this.updateCart();
        },
        clearCart(){
            if(this.cart!=null)
            {
                localStorage.removeItem('cart');
                this.cart.splice(0,this.cart.length);
            }
        },
        addNewObject(pid, pname, price, packing, measure) {
            if(price!="" || price!=null){
                this.cart.push({
                    product_id: pid,
                    name: pname,
                    mrp: price,
                    qty: 1,
                    cid: this.customer_id > 0 ? this.customer_id : "",
                    packing: packing,
                    measure: measure
                });
                
            }
        },
        heartClick(event,product_id){
            if(this.customer_id>0)
            {
                axios.get(this.apis.apiUrl+"/Customer/wishlist",{params:{token:localStorage.token,product_id:product_id,customer_id:this.customer_id}})
                .then(res=>{
                    console.log(res);
                    console.log(event.target.innerText);
                    if(event.target.innerText == 'favorite')
                    {
                        event.target.innerText = "favorite_border";
                    }
                    else
                    {
                        event.target.innerText = "favorite";
                    }
                })
            }
            else {
                console.log("Please login first");
            }
        },
        checkSession(){
            if(localStorage.getItem("customer_id") === null || localStorage.getItem("selected_db") === null)
            {
                this.$router.push('/') 
            }
        },
    },
}